<!-- Pet page: Header profile -->
@if (object) {
  <app-profile-header
    [imageUrl]="petImageUrl"
    [headerTitle]="petName"
    [placeholderImageUrl]="Constants.placeholderImgDog"
    [object]="object"
    [attributes]="petTitleAttributes"
    [currentSystemPreferenceCode]="currentSystemPreferenceCode$ | async"
    [currentBigMeasurementUnit]="currentBigMeasurementUnit$ | async"
  >
    <ng-content select="[right]" right></ng-content>
  </app-profile-header>
}
